module.exports = __webpack_public_path__ + "static/kilka-slow-o-content-marketingu_og-c99ae9d7aaee7e11cda94b288039a807.png";